import { __decorate, __extends } from "tslib";
import { CustomElement, attachShadowTemplate, upgradeProperty, coerceNumber } from '@tyler-components-web/core';
import { FilePickerAdapter } from './file-picker-adapter';
import { FilePickerFoundation } from './file-picker-foundation';
import { FILE_PICKER_CONSTANTS } from './file-picker-constants';
import { ButtonComponent } from '../button';
var template = require('./file-picker.html');
var styles = require('./file-picker.css');
var FilePickerComponent = /** @class */ (function (_super) {
    __extends(FilePickerComponent, _super);
    function FilePickerComponent() {
        var _this = _super.call(this) || this;
        attachShadowTemplate(_this, FILE_PICKER_CONSTANTS.elementName, template, styles);
        _this._foundation = new FilePickerFoundation(new FilePickerAdapter(_this));
        return _this;
    }
    Object.defineProperty(FilePickerComponent, "observedAttributes", {
        get: function () {
            return [
                FILE_PICKER_CONSTANTS.attributes.ACCEPT,
                FILE_PICKER_CONSTANTS.attributes.MAX_SIZE,
                FILE_PICKER_CONSTANTS.attributes.CAPTURE,
                FILE_PICKER_CONSTANTS.attributes.MULTIPLE,
                FILE_PICKER_CONSTANTS.attributes.DISABLED,
                FILE_PICKER_CONSTANTS.attributes.COMPACT,
                FILE_PICKER_CONSTANTS.attributes.BORDERLESS
            ];
        },
        enumerable: true,
        configurable: true
    });
    FilePickerComponent.prototype.initializedCallback = function () {
        upgradeProperty(this, 'accept');
        upgradeProperty(this, 'maxSize');
        upgradeProperty(this, 'capture');
        upgradeProperty(this, 'multiple');
        upgradeProperty(this, 'disabled');
        upgradeProperty(this, 'compact');
        upgradeProperty(this, 'borderless');
    };
    FilePickerComponent.prototype.connectedCallback = function () {
        this._foundation.initialize();
    };
    FilePickerComponent.prototype.attributeChangedCallback = function (name, oldValue, newValue) {
        switch (name) {
            case FILE_PICKER_CONSTANTS.attributes.ACCEPT:
                this.accept = newValue;
                break;
            case FILE_PICKER_CONSTANTS.attributes.MAX_SIZE:
                this.maxSize = coerceNumber(newValue);
                break;
            case FILE_PICKER_CONSTANTS.attributes.CAPTURE:
                this.capture = newValue;
                break;
            case FILE_PICKER_CONSTANTS.attributes.MULTIPLE:
                this.multiple = this.hasAttribute(FILE_PICKER_CONSTANTS.attributes.MULTIPLE);
                break;
            case FILE_PICKER_CONSTANTS.attributes.DISABLED:
                this.disabled = this.hasAttribute(FILE_PICKER_CONSTANTS.attributes.DISABLED);
                break;
            case FILE_PICKER_CONSTANTS.attributes.COMPACT:
                this.compact = this.hasAttribute(FILE_PICKER_CONSTANTS.attributes.COMPACT);
                break;
            case FILE_PICKER_CONSTANTS.attributes.BORDERLESS:
                this.borderless = this.hasAttribute(FILE_PICKER_CONSTANTS.attributes.BORDERLESS);
                break;
        }
    };
    Object.defineProperty(FilePickerComponent.prototype, "accept", {
        /** Gets and sets the allowed file types */
        get: function () {
            return this._foundation.accept;
        },
        set: function (value) {
            this._foundation.accept = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilePickerComponent.prototype, "maxSize", {
        /** Gets and sets the maximum allowed file size */
        get: function () {
            return this._foundation.maxSize;
        },
        set: function (value) {
            this._foundation.maxSize = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilePickerComponent.prototype, "capture", {
        /** Gets and sets the camera to use when capturing video or images */
        get: function () {
            return this._foundation.capture;
        },
        set: function (value) {
            this._foundation.capture = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilePickerComponent.prototype, "value", {
        /** Gets a FileList with each selected file */
        get: function () {
            return this._foundation.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilePickerComponent.prototype, "multiple", {
        /** Gets and sets whether multiple files are allowed */
        get: function () {
            return this._foundation.multiple;
        },
        set: function (value) {
            this._foundation.multiple = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilePickerComponent.prototype, "disabled", {
        /** Gets and sets whether the file picker is disabled */
        get: function () {
            return this._foundation.disabled;
        },
        set: function (value) {
            this._foundation.disabled = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilePickerComponent.prototype, "compact", {
        /** Gets and sets whether the file picker is compact */
        get: function () {
            return this._foundation.compact;
        },
        set: function (value) {
            this._foundation.compact = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilePickerComponent.prototype, "borderless", {
        /** Gets and sets whether the file picker is borderless */
        get: function () {
            return this._foundation.borderless;
        },
        set: function (value) {
            this._foundation.borderless = value;
        },
        enumerable: true,
        configurable: true
    });
    FilePickerComponent = __decorate([
        CustomElement({
            name: FILE_PICKER_CONSTANTS.elementName,
            dependencies: [ButtonComponent]
        })
    ], FilePickerComponent);
    return FilePickerComponent;
}(HTMLElement));
export { FilePickerComponent };
